import type { TunaEditor } from './plugin-types.js'

export const getEditorContainerId = (editor: TunaEditor) => `editor-container-${editor.id}`
